import React from 'react';
import { content, ContentType } from '../content/content';
import { statusType } from '../content/statusType';

export const statusRotation = ({
  setStatusText,
  textStatusInterval,
  contentType,
}: {
  setStatusText: (text: string) => void;
  textStatusInterval: number;
  contentType: ContentType;
}) => {
  const statusRotationTexts = Object.values(content[contentType].status)
    .filter(({ type }) => type === statusType.PENDING)
    .map(({ text }) => text);
  let statusRotationIndex = 0;
  let timeoutObj: number;
  let mounted = true;

  const statusRotation = () => {
    try {
      setStatusText(statusRotationTexts[statusRotationIndex]);
      statusRotationIndex = (statusRotationIndex + 1) % statusRotationTexts.length;
    } finally {
      if (!mounted) return;
      // setTimeout's type is different in Node.js and browser, so we cast it to number
      timeoutObj = setTimeout(statusRotation, textStatusInterval) as unknown as number;
    }
  };

  timeoutObj = setTimeout(statusRotation, textStatusInterval) as unknown as number;

  return () => {
    mounted = false;
    clearTimeout(timeoutObj);
  };
};
